import React from "react";
import "./Header.css";
import Logo from "./components/Logo";

const Header = ({ onNavigate }) => {
  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo-container">
          <button
            onClick={() => onNavigate("home")}
            className="logo-button"
            aria-label="Go to home"
          >
            <Logo />
          </button>
        </div>

        {/* Navigation links */}
        <nav className="navigation">
          <button
            onClick={() => onNavigate("privacy-policy")}
            className="nav-link"
          >
            Privacy Policy
          </button>
          <button
            onClick={() => onNavigate("terms-and-conditions")}
            className="nav-link"
          >
            Terms & Conditions
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
